import { useStyles } from '@archipro-design/aria';

import * as S from '@modules/professional/component/page-layout/PageLayout.style';
import { Outlet } from 'react-router';
import type {
    InfoPageLibraryTabsFragment,
    InfoPageTestimonialFragment,
} from 'generated/graphql';
import type { CompanyImagesProps } from '@modules/professional/component/about-tab/company-images/CompanyImages';
import type { TeamMemberView } from '@modules/professional/type';
import type { AwardItem } from '@modules/professional/component/about-tab/awards/Awards';
import type { APHandle } from '~/modules/root';

export const handle: APHandle = {
    showBannerAndLogoMobile: true,
    hideContactArchiPro: true,
};

export interface LocationState {
    clamped?: boolean;
}

export interface InfoPageData {
    libraryTabs: InfoPageLibraryTabsFragment[];
    companyImageResult: CompanyImagesProps | null;
    teamMembersResult: {
        teamMembers: TeamMemberView[];
        pageInfo: {
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            totalCount: number;
            currentPage: number;
        };
    };
    awardsResult: {
        awards: AwardItem[];
        pageInfo: {
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            totalCount: number;
            currentPage: number;
        };
    };
    blockSummary: string;
    professionalTestimonials: InfoPageTestimonialFragment[];
    professional: {
        id: number;
        title: string;
    };
}

const InfoPage = () => {
    const { css } = useStyles();

    return (
        <div className={css(S.PageContent)}>
            <div className={css(S.Container)}>
                <Outlet />
            </div>
        </div>
    );
};

export default InfoPage;
